import styles from "../../../../../../../styles.config";
import { readEvents } from "../../../services/CalendarService";
import moment from "moment";
import { mapStores, mapState } from "pinia";
import { useDashboardStore } from "../../../state/modules/dashboard";
import { useMainStore } from '../../../state/store';

export default {
    data: function() {
        return {
            calendarEvents: [],
            schedule: [],
            loadingEvents: false,
        }
    },
    computed: {
        ...mapStores(useDashboardStore),
        ...mapState(useMainStore, ['currentUser']),
        tmpSchedule() {
            return this.dashboardStore.tmpSchedule;
        },
        calendar() {
            return this.dashboardStore.calendar;
        }
    },
    methods: {
        async fetchEvents(fromDate, toDate) {
            if (this.currentUser?.primary_calendar_id !== null) {
                this.loadingEvents = true;
                if (this.schedule[this.parseDateString(fromDate, 'date')] === undefined) {
                    if (this.tmpSchedule[this.parseDateString(fromDate, 'date')] === undefined) {
                        readEvents(fromDate, toDate).then(async data => {
                            this.parseEvents(data).then(parsedData => {
                                if (this.schedule === []) {
                                    this.schedule = parsedData;
                                } else {
                                    this.schedule = { ...this.schedule, ...parsedData };
                                }
                                this.dashboardStore.setCalendarEvents(this.schedule);
                                this.getAttributes();
                            });
                        }).catch(() => {
                            this.errorLoadingEvents = true;
                        }).finally(() => this.loadingEvents = false)
                    } else {
                        this.schedule = this.dashboardStore.calendar;
                        await this.getAttributes();
                        this.loadingEvents = false;
                    }
                } else {
                    await this.getAttributes();
                    this.loadingEvents = false;
                }
            }
        },
        parseEvents(data) {
            return new Promise((resolve, reject) => {
                let parsedData = [];
                data.forEach((event, index) => {
                    let eventDate = new Date(event.start);
                    let dayString = this.parseDateString(eventDate);
                    let dateString = this.parseDateString(eventDate, 'date');
                    if (parsedData[dateString] === undefined) {
                        parsedData[dateString] = [];
                    }
                    if (parsedData[dateString][dayString] === undefined) {
                        parsedData[dateString][dayString] = [];
                    }
                    parsedData[dateString][dayString].push(event);
                })
                resolve(parsedData);
            })
        },
        parseDateString(date, type = 'day') {
            if (!date) return;
            if (type === 'day') {
                return 'day-' + date.getDate();
            } else {
                return 'date-' + (date.getFullYear() + "-" + (date.getMonth() + 1));
            }
        },
        getAttributes() {
            return new Promise((resolve, reject) => {
                this.calendarEvents = [];
                if (!moment().isSame(this.activeDate, 'day')) {
                    this.calendarEvents.push({
                        key: 'today',
                        highlight: {
                            style: {
                                backgroundColor: styles.colors.primary.DEFAULT,
                                opacity: '0.2',
                            },
                        },
                        dates: new Date(),
                    });
                }
                let activeDateString = this.parseDateString(this.activeDate, 'date');
                if (this.schedule[activeDateString] === undefined) return;
                for (let [dayKey, scheduleEvents] of Object.entries(this.schedule[activeDateString])) {
                    let eventDate = new Date(activeDateString.slice('date-'.length) + "-" + dayKey.slice('day-'.length));
                    if (eventDate.getDate() === this.activeDate.getDate()) continue; // skip if same day
                    let dayContents = this.dayContents(scheduleEvents);
                    if (dayContents["allDay"] !== undefined) {
                        this.calendarEvents.push({
                            key: dayKey + '-allDay',
                            bar: {
                                style: {
                                    backgroundColor: styles.colors.primary[80],
                                    borderRadius: '999px',
                                },
                            },
                            dates: eventDate,
                        });
                        continue;
                    }
                    if (dayContents["tasks"] !== undefined) {
                        this.calendarEvents.push({
                            key: dayKey + '-tasks',
                            dot: {
                                style: {
                                    backgroundColor: styles.colors.semantic.success.DEFAULT,
                                },
                            },
                            dates: eventDate,
                        });
                    }
                    if (dayContents["events"] !== undefined) {
                        this.calendarEvents.push({
                            key: dayKey + '-events',
                            dot: {
                                style: {
                                    backgroundColor: styles.colors.primary[80],
                                },
                            },
                            dates: eventDate,
                        });
                    }
                }
                resolve(this.calendarEvents);
            })
        },
        dayContents(calendarDay = []) { // Check wether the day contains events and tasks, return an array of amount of events and tasks
            let dayContents = [];
            if (calendarDay.length === 0) return dayContents;
            calendarDay.forEach(calendarEvent => {
                if (calendarEvent.isTask) {
                    dayContents['tasks'] = dayContents['tasks'] === undefined ? 1 : dayContents['tasks'] + 1;
                    return;
                }
                if (calendarEvent.isAllDay) {
                    dayContents['allDay'] = dayContents['allDay'] === undefined ? 1 : dayContents['allDay'] + 1;
                    return;
                }
                dayContents['events'] = dayContents['events'] === undefined ? 1 : dayContents['events'] + 1;
            });
            return dayContents;
        }
    }
}
